import { useMemo } from 'react';
import { RootState } from 'store';
import { useSelector } from 'react-redux';

import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { CARS_STATE } from '../../constants';
import { EMPTY_ARRAY } from 'shared/constants';

const useADRClassesLoadingStatus = () => {
  return useSelector((state: RootState) => state[CARS_STATE].adrClasses.loadingStatus);
};

export const useIsADRClassesLoading = () => {
  const adrClassesLoadingStatus = useADRClassesLoadingStatus();
  return checkIsLoading(adrClassesLoadingStatus);
};

export const useIsADRClassesDone = () => {
  const adrClassesLoadingStatus = useADRClassesLoadingStatus();
  return checkIsLoadingDone(adrClassesLoadingStatus);
};

export const useADRClasses = () => {
  return useSelector((state: RootState) => state[CARS_STATE].adrClasses.data);
};

export const useADRClassesList = () => {
  const adrClasses = useADRClasses();

  return useMemo(() => (adrClasses || EMPTY_ARRAY).map(({ name, description }) => ({
    key: name,
    value: description
  })), [adrClasses]);
};
